import axios from "axios";
import { stringify } from "qs";
import { formatRegionUrl } from "./utils/string-utils";

const axiosInstance = axios.create({
	baseURL: process.env.VUE_APP_HTTP_API_URI,
	withCredentials: true,
	headers: {
		Accept: "application/json, text/javascript, */*; q=0.01",
		"Content-Type": "application/x-www-form-urlencoded"
	}
});

const axiosJsonInstance = axios.create({
	baseURL: process.env.VUE_APP_HTTP_API_URI,
	withCredentials: true,
	headers: {
		Accept: "application/json, text/javascript, */*; q=0.01",
		"Content-Type": "application/json"
	}
});

const axiosJsonDirectInstance = axios.create({
	baseURL: process.env.VUE_APP_HTTP_API_URI,
	withCredentials: true,
	headers: {
		Accept: "application/json, text/javascript, */*; q=0.01",
		"Content-Type": "application/json"
	}
});

// When querying external api for external map layer
const axiosJsonExternalInstance = axios.create({
	baseURL: process.env.VUE_APP_HTTP_API_URI,
	withCredentials: false,
	headers: {
		Accept: "application/json, text/javascript, */*; q=0.01",
		"Content-Type": "application/json",
	}
});

// When uploading files we must create an axios instance with no content type set,
// axios will then correctly set the appropraite headers when uploading files.
const axiosNoContentTypeInstance = axios.create({
	baseURL: process.env.VUE_APP_HTTP_API_URI,
	withCredentials: true,
	headers: {
		Accept: "application/json, text/javascript, */*; q=0.01"
	}
});

axiosInstance.defaults.transformRequest = function(data, headers) {
	for (let prop in data) {
		if (data[prop] == null) {
			delete data[prop];
		}
	}
	return stringify(data);
};

axiosInstance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

axiosInstance.prototype.setApiBaseUrl = function(url: string) {
	// Ensure the URL ends with /api, unless it's running locally
	url = formatRegionUrl(url);

	axiosInstance.defaults.baseURL = url;
	axiosJsonInstance.defaults.baseURL = url;
	axiosJsonDirectInstance.defaults.baseURL = url;
	axiosJsonExternalInstance.defaults.baseURL = url;
	axiosNoContentTypeInstance.defaults.baseURL = url;
};

axiosInstance.prototype._originalBaseUrl = axiosInstance.defaults.baseURL;

axiosInstance.prototype.resetBackToOriginalBaseUrl = function() {
	axiosJsonInstance.defaults.baseURL = axiosInstance.prototype._originalBaseUrl;
	axiosInstance.defaults.baseURL = axiosInstance.prototype._originalBaseUrl;
	axiosJsonDirectInstance.defaults.baseURL = axiosInstance.prototype._originalBaseUrl;
	axiosJsonExternalInstance.defaults.baseURL = axiosInstance.prototype._originalBaseUrl;
	axiosNoContentTypeInstance.defaults.baseURL = axiosInstance.prototype._originalBaseUrl;
};

export { axiosInstance,
	axiosJsonInstance,
	axiosJsonDirectInstance,
	axiosJsonExternalInstance,
	axiosNoContentTypeInstance };
